<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm" class="flex flex-col">
  <mat-form-field *ngIf="data.input.hallmarkInfoList" appearance="outline" class="flex-1-1-100">
    <mat-label>Hallmark</mat-label>
    <!--<input formControlName="entityType" matInput placeholder="" required>-->
    <mat-select formControlName="selection" (selectionChange)="onSelectionChange($event)">
      <mat-option *ngFor="let data of (dropdownData$|async)" [value]="data">
        {{data.header}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="notification-message-container m-0 m-b-16 flex flex-row justify-between items-center">
    <div>
      <span>Note:</span> <span>The following keyterms will be used when auto-suggesting Hallmarks for a particular Case, based on the Case Description.</span>
    </div>
  </div>
  <div class="flex flex-row">
    <mat-form-field appearance="outline" class="m-r-10 full-grow-no-shrink-no-basis">
      <mat-label>Add Keyterm</mat-label>
      <input type="text" matInput formControlName="value" placeholder="Add Keyterm" [matAutocomplete]="auto"/>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">
          {{option}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button mat-button class="common-button" (click)=addKeyTerm()
            style="margin-bottom: 24px;position: relative;top: 4px;"
    >Add Keyterm
    </button>
  </div>
</form>

<div *ngIf="hallmarkInfo?.selectedTags?.length > 0" class="flex flex-row justify-start items-start">
  <mat-form-field class="w-p-100 keyterms-container" floatPlaceholder="always" floatLabel="always" appearance="outline">
    <mat-label>Selected Keyterms</mat-label>
    <input matInput placeholder="Input" style="display: none"
           particleAnalytics
           analyticsCategory="choice-filter-modal-item-editor"
           analyticsAction="entity-scope-input">
    <mat-chip-listbox aria-label="Fish selection">
      <mat-chip *ngFor="let selectedTag of hallmarkInfo?.selectedTags">
        <div class="flex flex-row">
          {{selectedTag}}
          <button class="close pointer"
                  particleAnalytics
                  analyticsCategory="roles-viewer"
                  analyticsAction="close-btn" (click)="removeSelectedTag(selectedTag)">
            <i class="fal fa-times"></i>
          </button>
        </div>
      </mat-chip>
    </mat-chip-listbox>

  </mat-form-field>
</div>
